import React, { createContext, useContext, useState } from 'react';

export const InventoryContext = createContext();

export const InventoryProvider = ({ children }) => {
    const [inventoryRadio, setInventoryRadio] = useState(1);
    const [distributor_id, setDistributorId] = useState("");
    return (
        <InventoryContext.Provider value={{ inventoryRadio, setInventoryRadio, distributor_id, setDistributorId }}>
            {children}
        </InventoryContext.Provider>
    );
};

export function useInventory() {
    const context = useContext(InventoryContext);
  
    if (!context) throw new Error("useAuth must be used within a authProvider");
  
    const { inventoryRadio, setInventoryRadio, distributor_id, setDistributorId } = context;
    return { inventoryRadio, setInventoryRadio, distributor_id, setDistributorId };
  }